import React from 'react'
import type { FC } from 'react'
import type { Theme } from '@material-ui/core/styles'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import { Typography, Button } from '@homeviews/shared-ui'
import type { MediaItem } from '@homeviews/models'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.colors.white,
      border: '1px solid #EAEBF0',
      padding: '10px 20px',
      width: '100%',
      position: 'absolute',
      left: 0,
      bottom: 0,
      zIndex: 2,
      [theme.breakpoints.down('sm')]: {
        position: 'fixed',
      },
    },
    inner: {
      display: 'flex',
      alignItems: 'center',
      marginRight: 'auto',
    },
    title: {
      fontSize: theme.typography.pxToRem(21),
      fontWeight: 500,
      letterSpacing: '-0.2px',
      lineHeight: theme.typography.pxToRem(22),
      marginRight: 10,
    },
    clearSelections: {
      color: theme.colors.primary,
      marginRight: 30,
      '&:hover': {
        cursor: 'pointer',
      },
    },
  }),
)

interface IProps {
  selected: MediaItem[]
  clearSelection: () => void
  triggerUseSelected: () => void
}

const MediaSelections: FC<IProps> = ({
  selected,
  clearSelection,
  triggerUseSelected,
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.inner}>
        <Typography className={classes.title}>
          {`${selected?.length || 0} ${
            selected?.length === 1 ? 'item' : 'items'
          } selected`}
        </Typography>
        <Typography
          className={classes.clearSelections}
          onClick={() => {
            clearSelection()
          }}
        >
          Clear selections
        </Typography>
      </div>
      <Button
        variant="contained"
        color="primary"
        customColor="primary"
        onClick={triggerUseSelected}
      >
        Use selected
      </Button>
    </div>
  )
}

export default MediaSelections
